function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import InputLabel from "./InputLabel";
import ErrorContainer from "./ErrorContainer";
import UploadButton from "../button/UploadButton";
import { _CoreInputWrapper, _InputWrapperDiv, _DropdownWrapper, _TransparentButton } from "./inputStyles";
import FontAwesome from 'react-fontawesome';
import uuid from 'uuid/v4';
var DropdownSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownSelect, _React$Component);
  var _super = _createSuper(DropdownSelect);
  function DropdownSelect(props) {
    var _this;
    _classCallCheck(this, DropdownSelect);
    _this = _super.call(this, props);
    _this.id = uuid();
    _this.state = {
      selectValue: props.selectValue
    };
    _this.updateValue = _this.updateValue.bind(_assertThisInitialized(_this));
    _this.onDropDownChange = _this.onDropDownChange.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(DropdownSelect, [{
    key: "updateValue",
    value: function updateValue(newValue) {
      this.setState({
        selectValue: newValue
      });
    }
  }, {
    key: "onDropDownChange",
    value: function onDropDownChange(valueParam) {
      var value = valueParam && valueParam.value !== undefined ? valueParam.value : valueParam;
      if (this.props.onChange) {
        this.props.onChange(value, this.props.inputId || this.props.name);
      } else if (this.props.input && this.props.input.onChange) {
        this.props.input.onChange(value, this.props.inputId || this.props.name);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(valueParam) {
      var value = valueParam && valueParam.value !== undefined ? valueParam.value : valueParam;
      if (this.props.onBlur) {
        this.props.onBlur(value);
      } else if (this.props.input && this.props.input.onBlur) {
        this.props.input.onBlur(this.props.input.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        clearable = _this$props.clearable,
        disabled = _this$props.disabled,
        error = _this$props.error,
        highlight = _this$props.highlight,
        input = _this$props.input,
        inputId = _this$props.inputId,
        inputValue = _this$props.inputValue,
        labelText = _this$props.labelText,
        loading = _this$props.loading,
        matchPos = _this$props.matchPos,
        meta = _this$props.meta,
        noPadding = _this$props.noPadding,
        noResultsText = _this$props.noResultsText,
        noTitle = _this$props.noTitle,
        onInputChange = _this$props.onInputChange,
        onOpen = _this$props.onOpen,
        openOnFocus = _this$props.openOnFocus,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        required = _this$props.required,
        searchable = _this$props.searchable,
        uploadButton = _this$props.uploadButton;
      var wrapperClassName = [required ? 'required' : null, error ? 'error' : null, disabled ? 'disabled' : null, 'dropdown-select'].filter(Boolean).join(' ');
      var value = inputValue !== null && inputValue !== undefined ? inputValue : input && input.value !== null && input.value !== undefined ? input.value : '';
      var elementClassName = required && (value === null || value.length === 0) ? 'empty' : undefined;
      return /*#__PURE__*/React.createElement(_CoreInputWrapper, {
        className: wrapperClassName
      }, /*#__PURE__*/React.createElement(_InputWrapperDiv, {
        noTitle: noTitle,
        noPadding: noPadding
      }, /*#__PURE__*/React.createElement(InputLabel, {
        labelText: labelText,
        required: required,
        htmlFor: this.id
      })), /*#__PURE__*/React.createElement(_DropdownWrapper, {
        className: elementClassName,
        noPadding: noPadding,
        highlight: highlight
      }, /*#__PURE__*/React.createElement(Select, {
        id: this.id,
        backspaceRemoves: clearable,
        className: elementClassName,
        clearable: clearable,
        deleteRemoves: clearable,
        disabled: disabled,
        inputProps: {
          'data-inputid': inputId
        },
        isLoading: loading,
        matchPos: matchPos || 'any',
        noResultsText: noResultsText == false ? false : noResultsText == undefined ? 'No results found' : noResultsText,
        onBlur: this.onBlur,
        onOpen: onOpen,
        onChange: this.onDropDownChange,
        onInputChange: onInputChange,
        options: options,
        placeholder: placeholder,
        searchable: searchable,
        value: value,
        openOnFocus: openOnFocus
        /* eslint-disable-next-line jsx-a11y/no-autofocus */,
        autoFocus: autoFocus,
        arrowRenderer: function arrowRenderer(_ref) {
          var onMouseDown = _ref.onMouseDown,
            isOpen = _ref.isOpen;
          return /*#__PURE__*/React.createElement(_TransparentButton, {
            onMouseDown: onMouseDown,
            "data-testid": "dropdown-arrow"
          }, /*#__PURE__*/React.createElement(FontAwesome, {
            name: isOpen ? 'caret-up' : 'caret-down',
            style: {
              color: '#999'
            }
          }));
        }
      }), uploadButton && /*#__PURE__*/React.createElement(UploadButton, this.props), /*#__PURE__*/React.createElement(ErrorContainer, {
        error: error || meta && meta.touched && meta.error
      })));
    }
  }]);
  return DropdownSelect;
}(React.Component); // @ts-expect-error TODO
DropdownSelect.propTypes = {
  clearable: PropTypes.bool,
  creatable: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  searchable: PropTypes.bool
};

// @ts-expect-error TODO
DropdownSelect.defaultProps = {
  clearable: false,
  creatable: false,
  disabled: false,
  error: null,
  onChange: undefined,
  required: false,
  searchable: true
};
export default DropdownSelect;